import { EBreakpoints } from "@/ui/composables/useBreakpoint";
export const mobileBreakpoint = `(max-width: ${EBreakpoints.MD - 1}px)`;
export const tabletBreakpoint = `(min-width: ${EBreakpoints.MD}px) and (max-width: ${EBreakpoints.LG - 1}px)`;
export const desktopBreakpoint = `(min-width: ${EBreakpoints.LG}px)`;
